import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, EMPTY } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GetPropertyTypesInterface, ITagsPropsName } from 'app/services/graphqlApi.service';
import { RestAPIService } from 'app/services/rest-api.service';
import { DataService } from '../data/data.service';
import { getPropertyTypes, getPropsNames } from '../constants/gql';
import { PropertyType } from '../create-properties/interfaces/interfaces';

@Injectable({ providedIn: 'root' })

export class PropertyService {
  public _removedPropertyId = new BehaviorSubject<string>('');
  public removedPropertyId$ = this._removedPropertyId.asObservable();

  constructor(
    private readonly apiService: RestAPIService,
    private readonly dataService: DataService,
    private readonly toastr: ToastrService) { }

  //#region getPropertTypes, getPropertyNames and deleteProperty methods

  /**
   * delete property
   * @param entityType entity type
   * @param entityUUID entity uuid
   * @param type type
   * @param uuid prop id
   */
  deleteProperty(entityType: string, entityUUID: string, type: string, uuid: string) {
    return this.apiService.delete(`${entityType}/${entityUUID}/${type}/${uuid}`)
      .subscribe(res => {
        console.log('resres: ', res);
        this.toastr.success('Property deleted successfully!');
        this._removedPropertyId.next(uuid);
        this.dataService._deletedId.next(uuid);
      }, err => {
        const message = err.error.error?.message || 'An error has occured.';
        this.toastr.error(message);
      });
  }

  /**
   * get prop types
   */
  getPropertTypes() {
    return this.apiService.getGQLData({ query: getPropertyTypes.query }).pipe(catchError(err => {
      const message = err.error.error?.message || 'An error has occured.';
      this.toastr.error(message);
      return EMPTY;
    }), map((response) => {
      const queryResponse: GetPropertyTypesInterface[] = response.data?.intellija_ref_property_types;
      return queryResponse.map(h => ({ id: h.id, name: h.name } || []) as PropertyType);
    }));
  }

  /**
* get Properties names
*/
  getPropertyNames() {
    return this.apiService.getGQLData({ query: getPropsNames.query }).pipe(catchError(err => {
      const message = err.error.error?.message || 'An error has occured.';
      this.toastr.error(message);
      return EMPTY;
    }), map((response) => (response.data?.intellija_properties || []) as ITagsPropsName[]));
  }

  //#endregion

}
